;(() => {
  function pageDirection() {
    return document.querySelector("html[dir], .body-inner[dir]")?.dir === "rtl"
      ? "rtl"
      : "ltr"
  }

  function isRTL() {
    return pageDirection() === "rtl"
  }

  function isLTR() {
    return !isRTL()
  }

  window.HB = window.HB || {}
  window.HB.pageDirection = pageDirection
  window.HB.isRTL = isRTL
  window.HB.isLTR = isLTR
})()
